export default {
  admin: () => import("/app/layouts/admin.vue"),
  default: () => import("/app/layouts/default.vue"),
  owner: () => import("/app/layouts/owner.vue")
}